import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcGridHeaderFilterForm]'
})
export class GridHeaderFilterFormDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
